import { fetchData, postData } from "./apis";

const path = "/inventory";

export const getItemUnitApi = (value) => {
  let endPoint = `${path}/get-item-units`;
  return postData(endPoint, value);
};

export const getItemOriginsApi = (value) => {
  let endPoint = `${path}/get-item-origins`;
  return postData(endPoint, value);
};

export const transferCheckApi = (value) => {
  let endPoint = `${path}/transfer-check`;
  return postData(endPoint, value);
};

export const apiAdjustmentDeleteApi = (value) => {
  let endPoint = `${path}/adjustment-delete`;
  return postData(endPoint, value);
};

export const apiAdjustmentRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-adjust-record-with-details`;
  return postData(endPoint, value);
};

export const deleteItemGroupApi = (value) => {
  let endPoint = `${path}/delete-item-group`;
  return postData(endPoint, value);
};

export const transferApproveApi = (value) => {
  let endPoint = `${path}/transfer-approve`;
  return postData(endPoint, value);
};

export const getTranferRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-transfer-record-with-details`;
  return postData(endPoint, value);
};

export const inventoryTransferDeleteApi = (value) => {
  let endPoint = `${path}/transfer-delete`;
  return postData(endPoint, value);
};

export const getItemCodeApi = (value) => {
  let endPoint = `${path}/get-item-code`;
  return postData(endPoint, value);
};
export const saveUnitManageApi = (value) => {
  let endPoint = `${path}/save-unit-manage`;
  return postData(endPoint, value);
};

export const transferVoucherApi = (value) => {
  let endPoint = `${path}/transfer-vouchers`;
  return postData(endPoint, value);
};

export const getItemModelsApi = (value) => {
  let endPoint = `${path}/get-item-models`;
  return postData(endPoint, value);
};

export const deleteItemUnitApi = (value) => {
  let endPoint = `${path}/delete-item-unit`;
  return postData(endPoint, value);
};

export const saveOriginManageApi = (value) => {
  let endPoint = `${path}/save-origin-manage`;
  return postData(endPoint, value);
};

export const deleteItemOriginApi = (value) => {
  let endPoint = `${path}/delete-item-origin`;
  return postData(endPoint, value);
};

export const saveModelManageApi = (value) => {
  let endPoint = `${path}/save-model-manage`;
  return postData(endPoint, value);
};

export const deleteItemModelApi = (value) => {
  let endPoint = `${path}/delete-item-model`;
  return postData(endPoint, value);
};

export const deleteItemCategoryApi = (value) => {
  let endPoint = `${path}/delete-item-category`;
  return postData(endPoint, value);
};

export const getStockReportApi = (value) => {
  let endPoint = `${path}/get-stock-report`;
  return postData(endPoint, value);
};

export const getAdjustmentVoucherNumberApi = () => {
  let endPoint = `${path}/get-adjustment-voucher-no`;
  return fetchData(endPoint);
};

export const getTransferVoucherNumberApi = () => {
  let endPoint = `${path}/get-transfer-voucher-no`;
  return fetchData(endPoint);
};

export const getItemLedgerApi = (value) => {
  let endPoint = `${path}/get-item-ledger`;
  return postData(endPoint, value);
};

export const saveItemApi = (value) => {
  let endPoint = `${path}/save-item`;
  return postData(endPoint, value);
};

export const saveItemRackApi = (value) => {
  let endPoint = `${path}/save-item-rack`;
  return postData(endPoint, value);
};
export const getItemRackApi = (value) => {
  let endPoint = `${path}/get-item-racks`;
  return postData(endPoint, value);
};
export const deleteItemRackApi = (value) => {
  let endPoint = `${path}/delete-item-rack`;
  return postData(endPoint, value);
};
export const saveItemUploadApi = (value) => {
  let endPoint = `${path}/item/upload-excel`;
  return postData(endPoint, value);
};

export const getProductTemplateApi = () => {
  let endPoint = `${path}/product/template`;
  return fetchData(endPoint);
};

export const getbranchList = (value) => {
  let endPoint = `${path}/get-branch-List`;
  return postData(endPoint, value);
};

export const saveproductpackingstructure = (value) => {
  let endPoint = `${path}/save-product-packing-structure`;
  return postData(endPoint, value);
};

export const getproductpackingstructure = (value) => {
  let endPoint = `${path}/get-product-packing-details`;
  return postData(endPoint, value);
};

export const deletepackingdata = (value) => {
  let endPoint = `${path}/delete-packing-data`;
  return postData(endPoint, value);
};

export const createTransferApi = (value) => {
  let endPoint = `${path}/create-transfer`;
  return postData(endPoint, value);
};
export const updateTransferApi = (value) => {
  let endPoint = `${path}/update-transfer`;
  return postData(endPoint, value);
};

export const createAdjustmentApi = (value) => {
  let endPoint = `${path}/create-adjustment`;
  return postData(endPoint, value);
};

export const updateAdjustmentApi = (value) => {
  let endPoint = `${path}/update-adjustment`;
  return postData(endPoint, value);
};
export const getManufacturesApi = (value) => {
  let endPoint = `${path}/get-manufactures`;
  return postData(endPoint, value);
};
export const saveManufacturesApi = (value) => {
  let endPoint = `${path}/save-manufacture`;
  return postData(endPoint, value);
};
export const getDistributorsApi = (value) => {
  let endPoint = `${path}/get-distributors`;
  return postData(endPoint, value);
};
export const saveDistributorsApi = (value) => {
  let endPoint = `${path}/save-distributor`;
  return postData(endPoint, value);
};